import React, { useState, useEffect } from 'react';
import { Navigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { apiRequest } from '../services/apiClient';
import '../styles/checkoutComplete.css';

const CheckoutComplete = () => {
  const { t } = useTranslation();

  const [status, setStatus] = useState(null);
  const [customerEmail, setCustomerEmail] = useState('');
  const [invoiceMode, setInvoiceMode] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const sessionId = params.get('session_id');
    const invoiceSent = params.get('invoice_sent');
    const emailFromUrl = params.get('email');

    if (invoiceSent) {
      setInvoiceMode(true);
      setStatus('invoice_sent');

      if (emailFromUrl) {
        setCustomerEmail(emailFromUrl);
      }

      return;
    }

    if (!sessionId) return;

    apiRequest(`/api/stripe/session-status?session_id=${sessionId}`)
      .then((data) => {
        setStatus(data.status);
        setCustomerEmail(data.customer_email);
      })
      .catch(console.error);
  }, []);

  if (status === 'open') return <Navigate to="/checkout" />;

  if (invoiceMode && status === 'invoice_sent') {
    return (
      <div className="checkout-success-wrapper">
        <div className="checkout-success-card">
          <div className="success-icon">✓</div>

          <h1>{t('invoice_sent_title')}</h1>

          <p className="subtitle">
            {t('invoice_sent_subtitle')}
          </p>

          <p className="main-text">
            {t('invoice_sent_text')}
          </p>

          <p className="email">{customerEmail}</p>

          <p className="main-text">
            {t('invoice_sent_setup_text')}
          </p>

          <p className="hint">
            {t('invoice_sent_hint')}
          </p>
        </div>
      </div>
    );
  }

  if (status === 'complete') {
    return (
      <div className="checkout-success-wrapper">
        <div className="checkout-success-card">
          <div className="success-icon">✓</div>

          <h1>{t('checkout_success_title')}</h1>

          <p className="subtitle">
            {t('checkout_success_subtitle')}
          </p>

          <p className="main-text">
            {t('checkout_success_setup_text')}
          </p>

          <p className="email">{customerEmail}</p>

          <p className="main-text">
            {t('checkout_success_password_text')}
          </p>

          <p className="hint">
            {t('checkout_success_hint')}
          </p>
        </div>
      </div>
    );
  }

  return null;
};

export default CheckoutComplete;